module.exports = __webpack_public_path__ + "static/media/logo_login.e17eb99a.png";